var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarketing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18.003,
    viewBox: "0 0 20 18.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4564",
    "data-name": "Group 4564",
    transform: "translate(-576 -211.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5881",
    "data-name": "Path 5881",
    d: "M18,8a3,3,0,0,1,0,6",
    transform: "translate(574 209)",
    fill: "none",
    stroke: "#bbc6d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5882",
    "data-name": "Path 5882",
    d: "M10,8V19a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V14",
    transform: "translate(574 209)",
    fill: "none",
    stroke: "#bbc6d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5883",
    "data-name": "Path 5883",
    d: "M12,8h0l4.524-3.77A.9.9,0,0,1,18,4.922V17.078a.9.9,0,0,1-1.476.692L12,14H4a1,1,0,0,1-1-1V9A1,1,0,0,1,4,8h8",
    transform: "translate(574 209)",
    fill: "none",
    stroke: "#bbc6d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketing);
export default __webpack_public_path__ + "static/media/marketing.3dea29cf.svg";
export { ForwardRef as ReactComponent };